export class NormalPayslipReq {
    id: number;
    employeeId: number;
    employeeName: string;
    employeeCode: string;
    employeeType: string;
    employeeCategory: string;
    designation: string;
    department: string;
    payrollMonth: string;
    factoryWorkingDays: string;
    attendance: string;
    basic?: string;
    hraAmount?: string;
    eduAmount?: string;
    medicalAmount?: string;
    splAmount?: string;
    conveyanceAmount?: string;
    petrolAmount?: string;
    shoeAmount?: string;
    washingAmount?: string;
    uniformAmount?: string;
    helperAmount?: string;
    productionAmount?: string;
    taAmount?: string;
    bonusAmount?: string;
    gross?: string;
    incentiveHrs?: string;
    calBasic?: string;
    calHra?: string;
    calEdu?: string;
    calMedical?: string;
    calSpl?: string;
    calConveyance?: string;
    calPetrol?: string;
    calShoe?: string;
    calWashing?: string;
    calUniform?: string;
    calHelper?: string;
    calProduction?: string;
    calTa?: string;
    calBonus?: string;
    calGross?: string;
    incentiveAmountPerHr?: string;
    totalIncentiveHr?: string;
    incentiveAmount?: string;
    totalEarnings?: string;
    epfAmount?: string;
    esicAmount?: string;
    messAmount?: string;
    othersAmount?: string;
    tds?: string;
    ProfessionalTax?: string;
    totalDeductions?: string;
    netSalary?: string;
    bank?: string;
    bankAcNo?: string;
    ifsc?: string;
    uan?: string;
    doj?: string;
    pan?: string;
    esi?: string;
    emailId?: string

    constructor(
        id: number,
        employeeId: number,
        employeeName: string,
        employeeCode: string,
        employeeType: string,
        employeeCategory: string,
        designation: string,
        department: string,
        payrollMonth: string,
        factoryWorkingDays: string,
        attendance: string,
        basic?: string,
        hraAmount?: string,
        eduAmount?: string,
        medicalAmount?: string,
        splAmount?: string,
        conveyanceAmount?: string,
        petrolAmount?: string,
        shoeAmount?: string,
        washingAmount?: string,
        uniformAmount?: string,
        helperAmount?: string,
        productionAmount?: string,
        taAmount?: string,
        bonusAmount?: string,
        gross?: string,
        incentiveHrs?: string,
        calBasic?: string,
        calHra?: string,
        calEdu?: string,
        calMedical?: string,
        calSpl?: string,
        calConveyance?: string,
        calPetrol?: string,
        calShoe?: string,
        calWashing?: string,
        calUniform?: string,
        calHelper?: string,
        calProduction?: string,
        calTa?: string,
        calBonus?: string,
        calGross?: string,
        incentiveAmountPerHr?: string,
        totalIncentiveHr?: string,
        incentiveAmount?: string,
        totalEarnings?: string,
        epfAmount?: string,
        esicAmount?: string,
        messAmount?: string,
        othersAmount?: string,
        tds?: string,
        ProfessionalTax?: string,
        totalDeductions?: string,
        netSalary?: string,
        bank?: string,
        bankAcNo?: string,
        ifsc?: string,
        uan?: string,
        doj?: string,
        pan?: string,
        esi?: string,
        emailId?: string
    ) {
        this.id = id;
        this.employeeId = employeeId;
        this.employeeName = employeeName;
        this.employeeCode = employeeCode;
        this.employeeType = employeeType;
        this.employeeCategory = employeeCategory;
        this.designation = designation;
        this.department = department;
        this.payrollMonth = payrollMonth;
        this.factoryWorkingDays = factoryWorkingDays;
        this.attendance = attendance;
        this.basic = basic;
        this.hraAmount = hraAmount;
        this.eduAmount = eduAmount;
        this.medicalAmount = medicalAmount;
        this.splAmount = splAmount;
        this.conveyanceAmount = conveyanceAmount;
        this.petrolAmount = petrolAmount;
        this.shoeAmount = shoeAmount;
        this.washingAmount = washingAmount;
        this.uniformAmount = uniformAmount;
        this.helperAmount = helperAmount;
        this.productionAmount = productionAmount;
        this.taAmount = taAmount;
        this.bonusAmount = bonusAmount;
        this.gross = gross;
        this.incentiveHrs = incentiveHrs;
        this.calBasic = calBasic;
        this.calHra = calHra;
        this.calEdu = calEdu;
        this.calMedical = calMedical;
        this.calSpl = calSpl;
        this.calConveyance = calConveyance;
        this.calPetrol = calPetrol;
        this.calShoe = calShoe;
        this.calWashing = calWashing;
        this.calUniform = calUniform;
        this.calHelper = calHelper;
        this.calProduction = calProduction;
        this.calTa = calTa;
        this.calBonus = calBonus;
        this.calGross = calGross;
        this.incentiveAmountPerHr = incentiveAmountPerHr;
        this.totalIncentiveHr = totalIncentiveHr;
        this.incentiveAmount = incentiveAmount;
        this.totalEarnings = totalEarnings;
        this.epfAmount = epfAmount;
        this.esicAmount = esicAmount;
        this.messAmount = messAmount;
        this.othersAmount = othersAmount;
        this.tds = tds;
        this.ProfessionalTax = ProfessionalTax;
        this.totalDeductions = totalDeductions;
        this.netSalary = netSalary;
        this.bank = bank;
        this.bankAcNo = bankAcNo;
        this.ifsc = ifsc
        this.uan = uan;
        this.doj = doj;
        this.pan = pan;
        this.esi = esi;
        this.emailId = emailId
    }
}